//Set header height
{
  function updateHeaderHeight() {
    let headerWrapper = document.querySelector('.js-header-wrapper');
    if (headerWrapper) {
      let mainContainer = document.querySelector('.js-main-content');
      let headerHeight = headerWrapper.offsetHeight;
      mainContainer.style.setProperty("--header-height", `${headerHeight}px`);
    }
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
}

//Js for horizontal scroll
{
  if (typeof gsap !== "undefined" && gsap.registerPlugin) {
    if (window.matchMedia("(min-width:990px)").matches) {
      gsap.registerPlugin(ScrollTrigger);
  
      let container = document.querySelector(".gsap-scroll-content");
  
      /* HUX: Breite aus den Sektionen selbst messen statt scrollWidth. scrollWidth wird durch die mitlaufende Navigation (.tabbing_block) aufgeblaeht, wenn ScrollTrigger mitten im Scrollen neu rechnet (Resize, Zoomwechsel). Folge war ein weisser Bereich nach dem Footer. */
      const huxSW = () => {
        const cl = container.getBoundingClientRect().left;
        let w = 0;
        for (const k of container.children) {
          const r = k.getBoundingClientRect();
          if (r.width) w = Math.max(w, r.right - cl);
        }
        return Math.ceil(w) || container.scrollWidth;
      };

      window.addEventListener("load", function () {
        gsap.to(container, {
          x: () => -huxSW() + window.innerWidth,
          ease: "none",
          scrollTrigger: {
            trigger: container,
            start: "top top",
            end: () => `+=${huxSW() - window.innerWidth}`,
            scrub: true,
            pin: true, invalidateOnRefresh: true,
            onUpdate: () => {
              document.body.style.setProperty('--scrolling-y-direction', `${window.scrollY}px`);
              if (!document.body.classList.contains("gsap-loaded")) {
                document.body.classList.add("gsap-loaded");
              }
            },
          },
        });
  
        ScrollTrigger.refresh();
      });
    }
  } else {
    console.warn("GSAP is not loaded");
  }
}

// Js for Scrolling Y
{
  document.body.style.setProperty('--scrolling-y-direction', '0px');
  /* HUX: Nur auf Desktop noetig (horizontales Scrollen). Auf Mobile loest das Setzen bei jedem Scroll-Event unnoetige Neuberechnungen aus (Flackern auf iOS) */
  const huxHzMq = window.matchMedia('(min-width: 990px)');
  window.addEventListener('scroll', () => {
    if (!huxHzMq.matches) return;
    let scrollTop = window.scrollY;
    document.body.style.setProperty('--scrolling-y-direction', `${scrollTop}px`);
  }, { passive: true });
} 

// Header menu newsletter
{
  let newsletterSubmitBtn = document.querySelector('.js-newsletter-submit-btn');
  let emailError = document.querySelector('.js-header-newsletter-error');
  let newsletterForm = document.querySelector('.js-menu-newsletter-form');
  let emailInput = newsletterForm?.querySelector('.js-header-newsletter-email');

  if (newsletterSubmitBtn && newsletterForm && emailInput) {
    newsletterSubmitBtn.addEventListener('click', (event) => {
      event.preventDefault();
      validateAndSubmit();
    });

    emailInput.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        validateAndSubmit();
      }
      removeError();
    });

    emailInput.addEventListener('input', removeError);

    function validateAndSubmit() {
      if (!isValidEmail(emailInput.value)) {
        emailError?.classList.remove('hidden');
      } else {
        try { sessionStorage.setItem('huxNlDrawer', JSON.stringify({ p: location.pathname, y: window.scrollY, t: Date.now() })); } catch (err) {}
        newsletterForm.submit();
      }
    }

    function removeError() {
      emailError?.classList.add('hidden');
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
  }

  // HUX: Nach der Anmeldung im Menue das Menue wieder oeffnen, damit die Bestaetigung direkt sichtbar ist
  let huxNlDrawer = null;
  try { huxNlDrawer = JSON.parse(sessionStorage.getItem('huxNlDrawer') || 'null'); sessionStorage.removeItem('huxNlDrawer'); } catch (err) {}
  if (huxNlDrawer && Date.now() - huxNlDrawer.t < 120000) {
    window.addEventListener('load', () => {
      if (huxNlDrawer.p === location.pathname) window.scrollTo(0, huxNlDrawer.y);
      setTimeout(() => {
        const huxDrawer = document.querySelector('#Details-menu-drawer-container');
        const huxSummary = huxDrawer ? huxDrawer.querySelector('summary') : null;
        if (huxDrawer && huxSummary && !huxDrawer.hasAttribute('open')) huxSummary.click();
        setTimeout(() => {
          const huxMsg = document.querySelector('.js-menu-newsletter-form .newsletter-form__message');
          if (huxMsg) huxMsg.focus({ preventScroll: true });
        }, 400);
      }, 200);
    });
  }
}


// const tabButtons = document.querySelectorAll('.tab-link');
// const tabContents = document.querySelectorAll('.tab-content');

// tabButtons.forEach(button => {
//   button.addEventListener('click', function() {
//     tabButtons.forEach(btn => btn.classList.remove('active'));
//     tabContents.forEach(content => content.classList.remove('active'));
//     button.classList.add('active');
//     const tabId = button.getAttribute('data-tab');
//     const activeTabContent = document.getElementById(tabId);
//     activeTabContent.classList.add('active');
//   });
// });
// tabButtons[0].classList.add('active');
// tabContents[0].classList.add('active');


// js for portfolio page
{
  let portfolioTabs = document.querySelectorAll('.js-portfolio-link-tab');
  let tabsContent = document.querySelectorAll('.js-portfolio-tab-content');
  let footerLinks = document.querySelectorAll('.js-portfolio-footer-link');
  let footerLink = footerLinks[0];
  let footerName = document.querySelector('.js-footer-project-name');

  if(portfolioTabs.length > 0) {
    portfolioTabs.forEach((tab) => {
      tab.addEventListener('click', () => {

        portfolioTabs.forEach(item => item.classList.remove('active'));
        tabsContent.forEach(content => content.classList.remove('active'));

        tab.classList.add('active');
        let tabId = tab.getAttribute('data-tab');
        let activeTabContent = document.getElementById(tabId);
        activeTabContent.classList.add('active');

        let nextProjextName = tab.getAttribute('data-next-project');
        let nextProjectUrl = tab.getAttribute('data-next-tab');
        if(nextProjextName) footerName.innerHTML = nextProjextName;
        if(nextProjectUrl)  footerLinks.forEach((link) => link.setAttribute('href', '#' + nextProjectUrl.replace(/^#/, '')));

        window.scrollTo({ top: 0, behavior: 'smooth' });  
      })
    })
  }

  footerLinks.forEach((footerLink) => {
    footerLink.addEventListener('click', (e) => {
      e.preventDefault();
      let tabLink = footerLink.getAttribute('href').replace(/^#/, '');
      let selectedTab = document.querySelector(`[data-tab="${tabLink}"]`);
      // selectedTab.click();
      
      window.scrollTo({ top: 0, behavior: 'smooth' });

      const onScroll = () => {
        if (window.scrollY === 0) {
          window.removeEventListener('scroll', onScroll);
          selectedTab.click();
        }
      };
      if (window.scrollY === 0) {
        selectedTab.click();
      } else {
        window.addEventListener('scroll', onScroll);
      }
    })
  });

  // HUX: Footer beim Laden mit dem aktiven Projekt abgleichen
  const huxActiveTab = document.querySelector('.js-portfolio-link-tab.active');
  if (huxActiveTab && footerName) {
    const huxNextName = huxActiveTab.getAttribute('data-next-project');
    const huxNextTab = huxActiveTab.getAttribute('data-next-tab');
    if (huxNextName) footerName.innerHTML = huxNextName;
    if (huxNextTab) footerLinks.forEach((link) => link.setAttribute('href', '#' + huxNextTab.replace(/^#/, '')));
  }
}

/* Heading White Space Remove JS Logic */
{
  document.addEventListener("DOMContentLoaded", function () {
    if (window.matchMedia("(max-width:749px)").matches) {
      const textboxes = document.querySelectorAll(".rich-heading-js");
      textboxes.forEach(function (textbox) {
        textbox.innerHTML = textbox.innerHTML.replace(/&nbsp;/g, " ");
      });
    }
  });
}

/* Active Tabs Center Display JS Logic */
{
  document.addEventListener("DOMContentLoaded", function () {
    const activeTab = document.querySelector(".legal-group .active");
    if (activeTab) {
      activeTab.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  });
}

// Js for legal, privacy policy, imprint blocks 
// {
//   if(window.matchMedia('(min-width:990px)')){
//     let currentUrl = window.location.href;
//     if (currentUrl.includes('/pages/legal') || currentUrl.includes('/pages/privacy-policy') || currentUrl.includes('/pages/imprint')) {
//       const cardBlocks = document.querySelectorAll('.js-card-block-wrapper');

//       cardBlocks.forEach((cardBlock) => {
//         const maxHeight = parseInt(getComputedStyle(cardBlock).maxHeight);
//         let totalHeight = 0;
//         let overflowContent = document.createElement('div'); 
//         overflowContent.classList.add('image-with-text__text', 'rte');

//         const heading = cardBlock.querySelector('h2');
//         const description = cardBlock.querySelector('.image-with-text__text');

//         if (heading) {
//           totalHeight += heading.offsetHeight;
//         }

//         if (description) {
//           if (cardBlock.scrollHeight <= maxHeight) return;

//           let cloneDescription = description.cloneNode(true);
//           let childNodes = Array.from(cloneDescription.childNodes);
//           description.innerHTML = ''; 

//           let tempContainer = document.createElement('div');

//           for (let i = 0; i < childNodes.length; i++) {
//             tempContainer.appendChild(childNodes[i]);
//             description.appendChild(tempContainer.cloneNode(true));
//             totalHeight = cardBlock.scrollHeight;

//             if (totalHeight > maxHeight) {
//               overflowContent.appendChild(childNodes[i]); 
//             }
//           }
//         }

//         if (overflowContent.innerHTML.trim() !== '') {
//           const parentListItem = cardBlock.closest('li');
//           const computedStyles = getComputedStyle(parentListItem);
//           const backgroundColor = computedStyles.backgroundColor;

//           const newListItem = document.createElement('li');
//           newListItem.classList.add('multicolumn-list__item', 'grid--3-col-desktop', 'grid__item', 'new-li-create');
//           newListItem.style.backgroundColor = backgroundColor;

//           const overflowWrapper = document.createElement('div');
//           overflowWrapper.classList.add('card-block-wrapper', 'js-card-block-wrapper');

//           if (description.classList.contains('subtitle')) {
//             overflowContent.classList.add('subtitle');
//           }

//           overflowWrapper.appendChild(overflowContent);
//           newListItem.appendChild(overflowWrapper);
//           parentListItem.insertAdjacentElement('afterend', newListItem);
//         }

//         cardBlock.style.maxHeight = maxHeight + 'px';
//         cardBlock.style.overflow = 'hidden';
//       });
//     }
//   }
// }

/* Gravity Animation JS */
let currentUrl = window.location.href;
if (currentUrl.includes('/pages/what-we-do') || document.querySelector('.template-page-pcon #gravityTags, .template-page-erp #gravityTags, .template-page-kosten #gravityTags')) {
  (function () {
    const WALL_THICKNESS = 80;
    const MATTER_CONTAINER = document.querySelector("#tagbuttonId");
    const MATTER_HELPER = document.querySelector("#gravityTags");
    const FALL_BUTTON = document.querySelector(".js-gravity-heading strong");
    const fallBtnHeading = document.querySelector(".js-gravity-heading");

    let Engine = Matter.Engine,
      Render = Matter.Render,
      Runner = Matter.Runner,
      Bodies = Matter.Bodies,
      World = Matter.World,
      Composite = Matter.Composite;

    let engine = Engine.create();
    let render = Render.create({
      element: MATTER_HELPER,
      engine: engine,
      background: "black",
      options: {
        width: MATTER_CONTAINER.offsetWidth,
        height: MATTER_CONTAINER.offsetHeight
      }
    });

    let domBodies = document.querySelectorAll(".js-tags");
    let extraTags = document.querySelectorAll(".js-extra-tags");
    let secondExtraTags = document.querySelectorAll(".js-second-extra-tags");
    let matterBodies = {};
    let runner;
    let leftWall, rightWall, ground;
    let toggleInterval;
    let currentWave = 1;

    setTimeout(() => {
      let getYScrollLength = window.scrollY;

      if (getYScrollLength < 150) {
        let hasStarted = false;
        document.body.style.overflow = "hidden";

        function enableScroll() {
          document.body.style.overflow = "";
        }

        function startAnimation(event) {
          if (!hasStarted) {
            event.preventDefault();
            hasStarted = true;
            init();
            setTimeout(enableScroll, 800);
          }
          // applyScrollForce();
        }

        // function applyScrollForce() {
        //   Object.values(matterBodies).forEach((body) => {
        //     Matter.Body.applyForce(body, body.position, {
        //       x: 0,
        //       y: 0.05,
        //     });
        //     Matter.Body.setVelocity(body, {
        //       x: body.velocity.x * 0.99,
        //       y: Math.min(body.velocity.y + 2, 12),
        //     });
        //   });
        // }

        window.addEventListener("wheel", startAnimation, { passive: false });
        window.addEventListener("touchmove", startAnimation, { passive: false });
        window.addEventListener("keydown", function (event) {
          if (event.key === "ArrowDown" || event.key === " ") {
            startAnimation(event);
          }
        });
      } else {
        init();
      }
    }, 1000);

    function init() {
      domBodies.forEach((tag) => {
        tag.classList.remove('hidden');
        tag.style.opacity = '0';
        tag.style.transition = 'opacity 0.3s ease-in';
        setTimeout(() => {
          tag.style.opacity = '1';
        }, 50);
      });

      createBounds();
      Composite.add(engine.world, [leftWall, rightWall, ground]);
      Render.run(render);
      runner = Runner.create();
      Runner.run(runner, engine);
      engine.world.gravity.y = 2;

      createMatterBodies(domBodies);
      World.add(engine.world, Object.values(matterBodies));
      window.requestAnimationFrame(updateElementPositions);
      window.addEventListener("resize", handleResize);

      setTimeout(() => {
        checkStability(() => {
          if (extraTags.length) {
            enableClickForWave(1);
          }
        });
      }, 1000);
    }

    function createBounds() {
      ground = Bodies.rectangle(
        MATTER_CONTAINER.offsetWidth / 2,
        MATTER_CONTAINER.offsetHeight + WALL_THICKNESS / 2,
        6000,
        WALL_THICKNESS,
        { isStatic: true }
      );

      leftWall = Bodies.rectangle(
        0 - WALL_THICKNESS / 2,
        MATTER_CONTAINER.offsetHeight / 2,
        WALL_THICKNESS,
        MATTER_CONTAINER.offsetHeight * 5,
        { isStatic: true }
      );

      rightWall = Bodies.rectangle(
        MATTER_CONTAINER.offsetWidth + WALL_THICKNESS / 2,
        MATTER_CONTAINER.offsetHeight / 2,
        WALL_THICKNESS,
        MATTER_CONTAINER.offsetHeight * 5,
        { isStatic: true }
      );
    }

    function createMatterBodies(elements) {
      elements.forEach(function (domBody) {
        if (!domBody.dataset.processed) {
          const randomX = MATTER_CONTAINER.offsetWidth / 2 + (Math.random() - 0.5) * 20;
          const startY = -MATTER_CONTAINER.offsetHeight - Math.random() * 100;

          let matterBody = Bodies.rectangle(
            randomX,
            startY,
            domBody.offsetWidth,
            domBody.offsetHeight,
            {
              chamfer: { radius: domBody.offsetHeight / 2 },
              restitution: 0.2,
              density: 0.008,
              angle: Math.random() * 0.5,
              friction: 0.3,
              frictionAir: 0.02,
            }
          );

          Matter.Body.setVelocity(matterBody, {
            x: (Math.random() - 0.5) * 3,
            y: 5 + Math.random() * 3
          });

          matterBody.sleepThreshold = 60;

          domBody.id = matterBody.id;
          matterBodies[matterBody.id] = matterBody;
          domBody.dataset.processed = "true";

          Matter.Events.on(engine, "afterUpdate", function () {
            if (matterBody.speed < 0.03) {
              Matter.Body.setVelocity(matterBody, {
                x: matterBody.velocity.x * 0.95,
                y: matterBody.velocity.y * 0.95
              });

              if (matterBody.speed < 0.01) {
                Matter.Sleeping.set(matterBody, true);
              }
            }
          });
        }
      });
    }

    function updateElementPositions() {
      Object.keys(matterBodies).forEach((id) => {
        let domBody = document.getElementById(id);
        let matterBody = matterBodies[id];

        if (domBody && matterBody) {
          domBody.style.transform = `translate(${matterBody.position.x - domBody.offsetWidth / 2}px, 
            ${matterBody.position.y - domBody.offsetHeight / 2}px) 
            rotate(${matterBody.angle}rad)`;
          domBody.style.transition = "transform 0.05s ease-out";
        }
      });
      window.requestAnimationFrame(updateElementPositions);
    }

    function handleResize() {
      render.canvas.width = MATTER_CONTAINER.offsetWidth;
      render.canvas.height = MATTER_CONTAINER.offsetHeight;
      Matter.Render.setPixelRatio(render, window.devicePixelRatio);

      Matter.Body.setPosition(ground,
        Matter.Vector.create(
          MATTER_CONTAINER.offsetWidth / 2,
          MATTER_CONTAINER.offsetHeight + WALL_THICKNESS / 2
        )
      );
      Matter.Body.setPosition(leftWall,
        Matter.Vector.create(
          0 - WALL_THICKNESS / 2,
          MATTER_CONTAINER.offsetHeight / 2
        )
      );
      Matter.Body.setPosition(rightWall,
        Matter.Vector.create(
          MATTER_CONTAINER.offsetWidth + WALL_THICKNESS / 2,
          MATTER_CONTAINER.offsetHeight / 2
        )
      );
    }

    function startWiggleEffect() {
      let toggleState = true;
      toggleInterval = setInterval(() => {
        if (toggleState) {
          fallBtnHeading.classList.remove("gravity-button");
        } else {
          if (fallBtnHeading.classList.contains("js-gravity-enabled")) {
            fallBtnHeading.classList.add("gravity-button");
          }
        }
        toggleState = !toggleState;
      }, 1000);
    }

    function enableClickForWave(waveNumber) {
      if (!FALL_BUTTON || FALL_BUTTON.dataset.clickEnabled === "true") return;

      FALL_BUTTON.dataset.clickEnabled = "true";
      fallBtnHeading.classList.add("js-gravity-enabled");
      startWiggleEffect();

      const clickHandler = () => {
        FALL_BUTTON.removeEventListener("click", clickHandler);
        fallBtnHeading.classList.remove("gravity-button");
        fallBtnHeading.classList.remove("js-gravity-enabled");
        clearInterval(toggleInterval);
        FALL_BUTTON.dataset.clickEnabled = "false";

        if (waveNumber === 1) {
          dropTags(extraTags);
        } else if (waveNumber === 2) {
          dropTags(secondExtraTags);
        }

        setTimeout(() => {
          checkStability(() => {
            if (waveNumber === 1) {
              currentWave = 2;
              if (secondExtraTags.length) {
                enableClickForWave(2);
              }
            }
          });
        }, 1000);
      };

      FALL_BUTTON.addEventListener("click", clickHandler);
    }

    function dropTags(tagNodeList) {
      tagNodeList.forEach((item, index) => {
        item.classList.remove("hidden");
        item.style.opacity = "0";
        item.style.transition = "opacity 0.4s ease-in";
        setTimeout(() => {
          item.style.opacity = "1";
        }, 50 + index * 30);
      });

      createMatterBodies(tagNodeList);
      World.add(engine.world, Object.values(matterBodies));
    }

    function checkStability(callback) {
      let allStable = Object.values(matterBodies).every(
        (body) => body.speed < 0.05
      );

      if (allStable) {
        callback?.();
      } else {
        setTimeout(() => checkStability(callback), 500);
      }
    }
  })();
}

if (currentUrl.includes('/pages/who-we-are')){
  if (window.matchMedia("(min-width:990px)").matches) {
    gsap.registerPlugin(ScrollTrigger);

    const section = document.querySelector(".experience-section");
    const barWrapper = section.querySelector(".our-experiencebar-wrapper");
    const progressBar = section.querySelector(".progressbar-inner");
    const scrollContent = document.querySelector(".our-experienc-wrapper");
    const scrollContainer = document.querySelector(".gsap-scroll-content");
    
    let lastX = 0;
    let isFixedClassApplied = false;
    // HUX: Position aus der Scrollposition berechnen statt aus getBoundingClientRect (vermeidet Nachhinken um ein Frame und beruecksichtigt Zoom)
    let huxSectionLeft0 = null;
    const huxMeasure = () => { huxSectionLeft0 = section.getBoundingClientRect().left - scrollContainer.getBoundingClientRect().left; };
    huxMeasure();
    ScrollTrigger.addEventListener('refresh', huxMeasure);
    
    ScrollTrigger.create({
      trigger: section,
      scroller: "body",
      start: () => { huxMeasure(); return huxSectionLeft0; },
      end: () => "+=" + (section.getBoundingClientRect().width - window.innerWidth),
      scrub: true,
      onUpdate: (self) => {
        const huxZoom = parseFloat(getComputedStyle(section).zoom) || 1;
        const huxLeft = huxSectionLeft0 - window.scrollY;
        const huxRight = huxLeft + section.getBoundingClientRect().width;
    
        const isStickyRange = huxLeft <= 0 && huxRight >= window.innerWidth;
    
        if (isStickyRange) {
          const newX = Math.round((30 - huxLeft) / huxZoom);
          if (newX !== lastX) {
              gsap.to(barWrapper, {
              x: newX,
              duration: 0,  
              ease: "none", 
              overwrite: false
            });
          // barWrapper.style.position = "fixed";
          // barWrapper.style.left = newX+"px";
          // barWrapper.style.top = "40px"; // same as original
          // barWrapper.style.width = "calc(100vw - 40px)"; // account for left offset
            lastX = newX;
          }
    
          // Add "fixed" class if not already added
          if (!isFixedClassApplied) {
            barWrapper.classList.add("fixed");
            isFixedClassApplied = true;
          }
    
        } else {
          // Remove "fixed" class when out of sticky zone
          if (isFixedClassApplied) {
            barWrapper.classList.remove("fixed");
            isFixedClassApplied = false;
          }
        }
    
        // 2. Progress bar width sync
        const scrollProgress = self.progress.toFixed(4) * 100;
        progressBar.style.width = (scrollProgress < 10) ? '5%' :`${scrollProgress}%`;
      }
    });
  }
  if (window.matchMedia("(max-width:989px)").matches) {
    /* HUX: Fortschrittsbalken ruckelfrei. Masse nur bei Resize/Load messen, Update einmal pro Frame, keine Hoehen-Animation waehrend dem Scrollen */
    const section = document.querySelector(".experience-section");
    const progressBar = section ? section.querySelector(".progressbar-inner") : null;
    if (section && progressBar) {
      let huxTop = 0, huxHeight = 1, huxTicking = false, huxLast = -1;
      progressBar.style.transition = 'none';
      const huxMeasure = () => {
        const r = section.getBoundingClientRect();
        huxTop = r.top + window.scrollY;
        huxHeight = section.offsetHeight || 1;
      };
      const huxUpdate = () => {
        huxTicking = false;
        const p = Math.min(100, Math.max(0, ((window.scrollY - huxTop) / huxHeight) * 100));
        const v = Math.round(p * 10) / 10;
        if (v !== huxLast) { progressBar.style.height = v + '%'; huxLast = v; }
      };
      huxMeasure(); huxUpdate();
      window.addEventListener('load', () => { huxMeasure(); huxUpdate(); });
      window.addEventListener('resize', () => { huxMeasure(); huxUpdate(); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(() => { huxMeasure(); }).observe(document.body);
      window.addEventListener('scroll', () => {
        if (!huxTicking) { huxTicking = true; requestAnimationFrame(huxUpdate); }
      }, { passive: true });
    }
  }
}


// JS for contact form
{
  if (!customElements.get('contact-form')) {
    customElements.define(
      'contact-form',
      class ContactForm extends HTMLElement {
        constructor() {
          super();
          this.form = this.querySelector('.js-contact-form');
          this.name = this.querySelector('.js-contact-name');
          this.email = this.querySelector('.js-contact-email');
          this.organization = this.querySelector('.js-contact-organization');
          this.message = this.querySelector('.js-contact-message');

          this.contactNameError = this.querySelector('.js-contact-name-error');
          this.contactEmailError = this.querySelector('.js-contact-email-error');
          this.contactOrganizationError = this.querySelector('.js-contact-organization-error');
          this.contactMessageError = this.querySelector('.js-contact-message-error');
          
          this.name.addEventListener('input', this.handleInput.bind(this, "name"));
          this.email.addEventListener('input', this.handleInput.bind(this, "email"));
          this.organization.addEventListener('input', this.handleInput.bind(this, "org"));
          this.message.addEventListener('input', this.handleInput.bind(this, "message"));

          this.submitButton = this.querySelector('.js-contact-button');
          this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
        }

        validateEmail(email) {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailPattern.test(email);
        }

        handleInput(field) {
          if (field == "name") this.contactNameError.classList.add('hidden');
          if (field == "email") this.contactEmailError.classList.add('hidden');
          if (field == "org") this.contactOrganizationError.classList.add('hidden');
          if (field == "message") this.contactMessageError.classList.add('hidden');
        }

        handleSubmit(e) {
          e.preventDefault();
          let returnFunction = false;

          if (this.name.value == "") {
            this.contactNameError.classList.remove('hidden');
            returnFunction = true;
          }
          if (!this.validateEmail(this.email.value)) {
            const huxDe = (document.documentElement.lang || '').indexOf('de') === 0;
            this.contactEmailError.innerHTML = this.email.value == "" ? (huxDe ? "Bitte gib deine E-Mail-Adresse ein" : "Please enter an email") : (huxDe ? "Bitte gib eine gültige E-Mail-Adresse ein" : "Please enter a valid email");
            this.contactEmailError.classList.remove('hidden');
            returnFunction = true;
          }
          if (this.message.value == "") {
            this.contactMessageError.classList.remove('hidden');
            returnFunction = true;
          }

          if (returnFunction) return;

          let text1 = window.messages_1;
          let bck_clr_1 = window.bck_clr_1;
          let txt_clr_1 = window.txt_clr_1;

          let text2 = window.messages_2;
          let bck_clr_2 = window.bck_clr_2;
          let txt_clr_2 = window.txt_clr_2;

          let text3 = window.messages_3;
          let bck_clr_3 = window.bck_clr_3;
          let txt_clr_3 = window.txt_clr_3;

          const updateButton = (text, bg, txt) => {
            if (text) {
              this.submitButton.innerHTML = text;
              this.submitButton.style.background = bg;
              this.submitButton.style.color = txt;
              return true;
            }
            return false;
          };

          let delay = 0;

          if (updateButton(text1, bck_clr_1, txt_clr_1)) delay = 1500;

          setTimeout(() => {
            if (updateButton(text2, bck_clr_2, txt_clr_2)) {
              setTimeout(() => {
                if (updateButton(text3, bck_clr_3, txt_clr_3)) {
                  setTimeout(() => this.form.submit(), 1500);
                } else {
                  this.form.submit();
                }
              }, 1500);
            } else if (updateButton(text3, bck_clr_3, txt_clr_3)) {
              setTimeout(() => this.form.submit(), 1500);
            } else {
              this.form.submit();
            }
          }, delay);
        }
      }
    );
  }
}

/* Slider Arrow JS Logic */
{
  document.addEventListener("click", function (event) {
    if (event.target.closest(".btn-prev-slider-arrow")) { const prevSection = event.target.closest(".shopify-section"); const prevButton = prevSection && prevSection.querySelector(".slider-button--prev"); if (prevButton) { prevButton.click(); } } if (event.target.closest(".btn-next-slider-arrow")) {
      const nextButton = document.querySelector(".js-arrow-slide-right");
      if (nextButton) {
        nextButton.click();
      }
    }
  });
}

// Tinder Slider

if (document.querySelector('.multiple-card-wrapper') && document.getElementById('nope') && document.getElementById('love') && typeof Hammer !== 'undefined') {
  'use strict';

  var tinderContainer = document.querySelector('.multiple-card-wrapper');
  var allCards = document.querySelectorAll('.card-inner-wrapper');
  var nope = document.getElementById('nope');
  var love = document.getElementById('love');

  function initCards(card, index) {
    var newCards = document.querySelectorAll('.card-inner-wrapper:not(.removed)');

    newCards.forEach(function (card, index) {
      if (window.matchMedia("(min-width:990px)").matches) {
        if(index > 2) {
          var widthValue = 60;
          var leftValue = 30;
          card.style.transform = `translateY(-30px)`;
        } else {
          var widthValue = (index + 1) * 20;
          var leftValue = (index + 1) * 10;
        }
        card.style.zIndex = index + 1;
        card.style.width = `calc(100% + ${widthValue}px)`;
        card.style.left = `-${leftValue}px`;
      }
      if (window.matchMedia("(max-width:989px)").matches) {
        if(index > 2) {
          var widthValue = 37.5;
          var leftValue = 18.75;
          card.style.transform = `translateY(-18.75px)`;
        } else {
          var widthValue = (index + 1) * 12.5;
          var leftValue = (index + 1) * 6.25;
        }
        card.style.zIndex = index + 1;
        card.style.width = `calc(100% + ${widthValue}px)`;
        card.style.left = `-${leftValue}px`;
      }
    });
    
    tinderContainer.classList.add('loaded');
  }

  initCards();

  allCards.forEach(function (el) {
    var hammertime = new Hammer(el);

    hammertime.on('pan', function (event) {
      el.classList.add('moving');
    });

    hammertime.on('pan', function (event) {
      if (event.deltaX === 0) return;
      if (event.center.x === 0 && event.center.y === 0) return;

      tinderContainer.classList.toggle('tinder_love', event.deltaX > 0);
      tinderContainer.classList.toggle('tinder_nope', event.deltaX < 0);

      var xMulti = event.deltaX * 0.03;
      var yMulti = event.deltaY / 80;
      var rotate = xMulti * yMulti;

      event.target.style.transform = 'translate(' + event.deltaX + 'px, ' + event.deltaY + 'px) rotate(' + rotate + 'deg)';

    });

    hammertime.on('panend', function (event) {
      el.classList.remove('moving');
      tinderContainer.classList.remove('tinder_love');
      tinderContainer.classList.remove('tinder_nope');

      var moveOutWidth = document.body.clientWidth;
      var keep = Math.abs(event.deltaX) < 80 || Math.abs(event.velocityX) < 0.5;

      event.target.classList.toggle('removed', !keep);

      if (keep) {
        event.target.style.transform = '';
      } else {
        var endX = Math.max(Math.abs(event.velocityX) * moveOutWidth, moveOutWidth);
        var toX = event.deltaX > 0 ? endX : -endX;
        var endY = Math.abs(event.velocityY) * moveOutWidth;
        var toY = event.deltaY > 0 ? endY : -endY;
        var xMulti = event.deltaX * 0.03;
        var yMulti = event.deltaY / 80;
        var rotate = xMulti * yMulti;

        event.target.style.transform = 'translate(' + toX + 'px, ' + (toY + event.deltaY) + 'px) rotate(' + rotate + 'deg)';
        initCards();
      }
    });
  });

  function createButtonListener(love) {
    return function (event) {
      var cards = document.querySelectorAll('.card-inner-wrapper:not(.removed)');
      var moveOutWidth = document.body.clientWidth * 1.5;
      if (!cards.length) return false;

      var card = cards[cards.length - 1];

      card.classList.add('removed');

      if (love) {
        card.style.transform = 'rotate(5deg) translate(50px, 10px)';  
          setTimeout(() => {
          card.style.transform = 'translate(' + moveOutWidth + 'px, -100px)';
        }, 1000);     
      } else {    
        card.style.transform = 'rotate(-5deg) translate(-50px, 10px)';   
        setTimeout(() => {
          card.style.transform = 'translate(' + -moveOutWidth + 'px, -100px)'; 
        }, 1000);
      }

      initCards();

      event.preventDefault();
    };
  }

  var nopeListener = createButtonListener(false);
  var loveListener = createButtonListener(true);

  nope.addEventListener('click', nopeListener);
  love.addEventListener('click', loveListener);
}

/* Tinder Card Hover Animation JS */
{
  let wrapper = document.querySelector('.newsletter-box-main-wrapper');
  if(wrapper) {
    wrapper.addEventListener('mouseenter', () => {
      wrapper.classList.add('hovered');
    });
  }
}

// Contact form adjustment
{
  window.addEventListener('load', () => {
    const currentUrl = window.location.href;
    
    if (
      currentUrl.includes('/work-with-us') &&
      window.matchMedia("(max-width:990px)").matches &&
      currentUrl.includes('contact_posted=true') &&
      window.location.hash === '#ContactForm'
    ) {
      setTimeout(() => {
        const contactForm = document.querySelector('.js-contact-form-custom');
        if (contactForm) {
          window.scrollTo({
            top: contactForm.offsetTop,
            behavior: "smooth",
          });
        }
      }, 500);
    }

    if(
      currentUrl.includes('/what-we-do') &&
      window.matchMedia("(max-width:990px)").matches &&
      currentUrl.includes('contact_posted=true') &&
      window.location.hash === '#ContactForm'
    ) {
      setTimeout(() => {
        let contactFormBlock = document.querySelector('.js-contact-form-custom');
        let contactFormContainer = document.querySelector('.js-contact-form-container');
        let headerContainer = document.querySelector('.js-header');
        if (contactFormBlock && contactFormContainer) {
          window.scrollTo({
            top: + contactFormContainer.offsetTop + contactFormBlock.offsetTop - headerContainer.offsetHeight,
            behavior: "smooth",
          });
        }
      }, 500);
    }
  });
}

// Js for overlay header menu closing
{
  let mainContent = document.querySelector(".js-main-content");
  let summaryClose = document.querySelector(".js-close-button");

  mainContent.addEventListener('click', () => {
    const menuDrawer = document.querySelector(".js-menu-drawer");

    if (menuDrawer && menuDrawer.classList.contains("menu-opening")) {
      summaryClose.click();
    }
  });
}

/* Button Scroll Animation JS */
{
  window.addEventListener("DOMContentLoaded", () => {
    const scrollWrapper = document.getElementById("scrollTag");
    const newsTicker = document.getElementById("scrollTagWrapper");
  
    if (!scrollWrapper || !newsTicker) return;
  
    const buttons = scrollWrapper.querySelectorAll(".scroll-tag-js");
  
    let currentIndex = 0;
  
    function scrollToButton(index) {
      const target = buttons[index];
      const offset = target.offsetTop;
      scrollWrapper.style.transform = `translateY(-${offset}px)`;
      newsTicker.style.height = `${target.offsetHeight}px`;
    }
  
    // Initial scroll
    scrollToButton(currentIndex);
  
    // Scroll every 1.5s
    setInterval(() => {
      currentIndex = (currentIndex + 1) % buttons.length;
      scrollToButton(currentIndex);
    }, 1500);
  });  
}

/* HUX Newsletter: Position nach Anmeldung halten */ { const huxNlKey = 'huxNewsletterScroll'; document.addEventListener('submit', function (e) { const f = e.target; if (f && f.classList && f.classList.contains('newsletter-form')) { try { sessionStorage.setItem(huxNlKey, JSON.stringify({ p: location.pathname, y: window.scrollY, t: Date.now() })); } catch (err) {} } }, true); window.addEventListener('load', function () { let d = null; try { d = JSON.parse(sessionStorage.getItem(huxNlKey) || 'null'); sessionStorage.removeItem(huxNlKey); } catch (err) {} if (!d || d.p !== location.pathname || Date.now() - d.t > 120000) return; setTimeout(function () { window.scrollTo(0, d.y); }, 60); }); } // Project Page Purticular Tabs Active JS
{
  let projectLists = document.querySelectorAll('.js-project-list-item');
  if(projectLists.length > 0) {
    projectLists.forEach((item) => {
      item.addEventListener('click', () => {
        sessionStorage.setItem('projectListClicked', 'true');
      })
    })
  }
  if(sessionStorage.getItem('projectListClicked') == "true" && window.location.href.includes('/pages/portfolio')) {
    let urlHash = (window.location.hash || '').replace('#', '');
    let tab = document.querySelector(`.js-portfolio-link-tab[data-project-name='${urlHash}']`);
    if(tab) {
      tab.click();
    }
    history.replaceState(null, '', window.location.pathname + window.location.search);
    sessionStorage.removeItem('projectListClicked');
  }
}

/* HUX what we do: Details zu den Listenpunkten. Antippen/Klick oeffnet und schliesst, Escape und Klick ausserhalb schliessen. */
{
  const huxDetails = document.querySelectorAll('.hux-detail');
  if (huxDetails.length) {
    const huxCloseDetails = (except) => {
      huxDetails.forEach((item) => {
        if (item === except) return;
        item.classList.remove('is-open');
        const trigger = item.querySelector('.hux-detail__trigger');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };
    huxDetails.forEach((item) => {
      const trigger = item.querySelector('.hux-detail__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const open = !item.classList.contains('is-open');
        huxCloseDetails(item);
        item.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
}

/* HUX: Horizontales Scrollen mit Trackpad und Pfeiltasten, Fokus sichtbar halten (Desktop) */
{
  const huxHz = document.querySelector('.gsap-scroll-content');
  if (huxHz && window.matchMedia('(min-width: 990px)').matches) {
    const huxIsField = (el) => el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName));
    window.addEventListener('wheel', (e) => {
      if (e.ctrlKey || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      if (e.target.closest && e.target.closest('.project-image-group, .legal-group, .menu-drawer, [data-hux-own-scroll]')) return;
      e.preventDefault();
      window.scrollBy(0, e.deltaX);
    }, { passive: false });
    window.addEventListener('keydown', (e) => {
      if (e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || huxIsField(document.activeElement)) return;
      if (document.querySelector('.menu-drawer-container[open], details[open] > .menu-drawer')) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        window.scrollBy({ top: (e.key === 'ArrowRight' ? 1 : -1) * Math.round(window.innerWidth * 0.4), behavior: 'smooth' });
      }
    });
    document.addEventListener('focusin', (e) => {
      const el = e.target;
      if (!el || !huxHz.contains(el) || !el.getBoundingClientRect) return;
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return;
      if (r.left < 0 || r.right > window.innerWidth) {
        window.scrollTo({ top: Math.max(0, window.scrollY + r.left - Math.round(window.innerWidth * 0.25)), behavior: 'auto' });
      }
    });
  }
}

/* HUX: Analytics-Ereignisse fuer Google Tag Manager (dataLayer) */
{
  window.dataLayer = window.dataLayer || [];
  const huxPush = (event, data) => { try { window.dataLayer.push(Object.assign({ event: event, page_path: location.pathname }, data || {})); } catch (err) {} };
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.indexOf('calendly.com') > -1) huxPush('calendly_click', { link_url: href });
    else if (href.indexOf('mailto:') === 0) huxPush('email_click', { link_url: href });
    else if (href.indexOf('tel:') === 0) huxPush('phone_click', { link_url: href });
  }, true);
  const huxForm = document.querySelector('.js-contact-form');
  if (huxForm) {
    huxForm.addEventListener('focusin', () => huxPush('contact_start'), { once: true });
  }
  const huxQs = location.search;
  if (huxQs.indexOf('contact_posted=true') > -1) huxPush('contact_submit');
  if (huxQs.indexOf('customer_posted=true') > -1) huxPush('newsletter_signup');
  const huxNlBtn = document.querySelector('.js-newsletter-submit-btn');
  if (huxNlBtn) {
    huxNlBtn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); huxNlBtn.click(); }
    });
  }
}
